import { ActivitySchedule } from './space-activity.helpers';

export const SCHEDULES_OTHER: ActivitySchedule[] = [
  {
    operation: {}, // 24/7
    properties: {
      occupantMultiplier: 0, // No occupants in the space
      heatSet: 18, // Staircases etc have a lower heat set
    },
  },
];

// TODO: Add all properties to each new activity ()
// Vardagar = 1–5, Helg = 6–7
export const RESIDENTIAL_DEFAULT_SCHEDULES: ActivitySchedule[] = [
  // ---------------- VARDAGAR (1–5) ----------------
  // 00–05
  {
    operation: { wdays: [[1, 5]], hours: [[0, 5]] },
    properties: {
      occupantMultiplier: 0.6, // 6h → 3.6  (del av 13h/dygn)
      activityMultiplier: 0.59, // 6h → 3.54
    },
  },
  // 06–08
  {
    operation: { wdays: [[1, 5]], hours: [[6, 8]] },
    properties: {
      occupantMultiplier: 0.9, // 3h → 2.7
      activityMultiplier: 1.3, // 3h → 3.90
    },
  },
  // 09–15
  {
    operation: { wdays: [[1, 5]], hours: [[9, 15]] },
    properties: {
      occupantMultiplier: 0.1, // 7h → 0.7  (borta)
      activityMultiplier: 0.7, // 7h → 4.90
    },
  },
  // 16–21
  {
    operation: { wdays: [[1, 5]], hours: [[16, 21]] },
    properties: {
      occupantMultiplier: 0.8, // 6h → 4.8
      activityMultiplier: 1.57, // 6h → 9.42  (kvällstopp)
    },
  },
  // 22–23
  {
    operation: { wdays: [[1, 5]], hours: [[22, 23]] },
    properties: {
      occupantMultiplier: 0.6, // 2h → 1.2
      activityMultiplier: 1.12, // 2h → 2.24
    },
  },

  // ---------------- HELG (6–7) ----------------
  // 00–08
  {
    operation: { wdays: [[6, 7]], hours: [[0, 8]] },
    properties: {
      occupantMultiplier: 0.85, // 9h → 7.65
      activityMultiplier: 0.8, // 9h → 7.20
    },
  },
  // 09–12
  {
    operation: { wdays: [[6, 7]], hours: [[9, 12]] },
    properties: {
      occupantMultiplier: 0.75, // 4h → 3.00
      activityMultiplier: 1.1, // 4h → 4.40
    },
  },
  // 13–21
  {
    operation: { wdays: [[6, 7]], hours: [[13, 21]] },
    properties: {
      occupantMultiplier: 0.55, // 9h → 4.95
      activityMultiplier: 1.2, // 9h → 10.80
    },
  },
  // 22–23
  {
    operation: { wdays: [[6, 7]], hours: [[22, 23]] },
    properties: {
      occupantMultiplier: 0.45, // 2h → 0.90
      activityMultiplier: 0.8, // 2h → 1.60
    },
  },
];

export const OFFICE_DEFAULT_SCHEDULES: ActivitySchedule[] = [
  // Vardagar (1–5)
  {
    operation: { wdays: [[1, 5]], hours: [[0, 5]] },
    properties: {
      occupantMultiplier: 0.05,
      activityMultiplier: 0.4,
      ventFlowPerM2InM3PerS: 0.00015,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[6, 8]] },
    properties: {
      occupantMultiplier: 0.3,
      activityMultiplier: 0.8,
      ventFlowPerM2InM3PerS: 0.0003,
      heatSet: 21,
      coolSet: 24,
      deadbandK: 3,
      postHeatingTemp: 17,
      preCoolingTemp: 18,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[9, 12]] },
    properties: {
      occupantMultiplier: 0.9,
      activityMultiplier: 1.5,
      ventFlowPerM2InM3PerS: 0.0005,
      heatSet: 21,
      coolSet: 24,
      deadbandK: 3,
      postHeatingTemp: 17,
      preCoolingTemp: 17,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[13, 17]] },
    properties: {
      occupantMultiplier: 0.9,
      activityMultiplier: 1.5,
      ventFlowPerM2InM3PerS: 0.0005,
      heatSet: 21,
      coolSet: 24,
      deadbandK: 3,
      postHeatingTemp: 17,
      preCoolingTemp: 17,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[18, 20]] },
    properties: {
      occupantMultiplier: 0.3,
      activityMultiplier: 0.8,
      ventFlowPerM2InM3PerS: 0.0003,
      heatSet: 20,
      coolSet: 25,
      deadbandK: 3,
      postHeatingTemp: 17,
      preCoolingTemp: 18,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[21, 23]] },
    properties: {
      occupantMultiplier: 0.1,
      activityMultiplier: 0.5,
      ventFlowPerM2InM3PerS: 0.0002,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
  // Helg (6–7)
  {
    operation: { wdays: [[6, 7]], hours: [[0, 8]] },
    properties: {
      occupantMultiplier: 0.05,
      activityMultiplier: 0.4,
      ventFlowPerM2InM3PerS: 0.00015,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
  {
    operation: { wdays: [[6, 7]], hours: [[9, 17]] },
    properties: {
      occupantMultiplier: 0.1,
      activityMultiplier: 0.7,
      ventFlowPerM2InM3PerS: 0.0002,
      heatSet: 20,
      coolSet: 26,
      deadbandK: 3,
      postHeatingTemp: 17,
      preCoolingTemp: 18,
    },
  },
  {
    operation: { wdays: [[6, 7]], hours: [[18, 23]] },
    properties: {
      occupantMultiplier: 0.05,
      activityMultiplier: 0.4,
      ventFlowPerM2InM3PerS: 0.00015,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
];

export const SCHOOL_DEFAULT_SCHEDULES: ActivitySchedule[] = [
  // Vardagar (1–5)
  {
    operation: { wdays: [[1, 5]], hours: [[0, 6]] },
    properties: {
      occupantMultiplier: 0.02,
      activityMultiplier: 0.2,
      ventFlowPerM2InM3PerS: 0.00015,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[7, 7]] },
    properties: {
      occupantMultiplier: 0.4,
      activityMultiplier: 0.6,
      ventFlowPerM2InM3PerS: 0.0003,
      heatSet: 21,
      coolSet: 24,
      deadbandK: 3,
      postHeatingTemp: 17,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[8, 11]] },
    properties: {
      occupantMultiplier: 0.9,
      activityMultiplier: 1.4,
      ventFlowPerM2InM3PerS: 0.0005,
      heatSet: 21,
      coolSet: 24,
      deadbandK: 3,
      postHeatingTemp: 17,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[12, 12]] },
    properties: {
      occupantMultiplier: 0.7,
      activityMultiplier: 1.2,
      ventFlowPerM2InM3PerS: 0.0005,
      heatSet: 21,
      coolSet: 24,
      deadbandK: 3,
      postHeatingTemp: 17,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[13, 15]] },
    properties: {
      occupantMultiplier: 0.9,
      activityMultiplier: 1.4,
      ventFlowPerM2InM3PerS: 0.0005,
      heatSet: 21,
      coolSet: 24,
      deadbandK: 3,
      postHeatingTemp: 17,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[16, 17]] },
    properties: {
      occupantMultiplier: 0.3,
      activityMultiplier: 0.8,
      ventFlowPerM2InM3PerS: 0.0003,
      heatSet: 20,
      coolSet: 25,
      deadbandK: 3,
      postHeatingTemp: 17,
    },
  },
  {
    operation: { wdays: [[1, 5]], hours: [[18, 23]] },
    properties: {
      occupantMultiplier: 0.05,
      activityMultiplier: 0.3,
      ventFlowPerM2InM3PerS: 0.00015,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
  // Helg (6–7)
  {
    operation: { wdays: [[6, 7]], hours: [[0, 9]] },
    properties: {
      occupantMultiplier: 0.02,
      activityMultiplier: 0.2,
      ventFlowPerM2InM3PerS: 0.0001,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
  {
    operation: { wdays: [[6, 7]], hours: [[10, 14]] },
    properties: {
      occupantMultiplier: 0.1,
      activityMultiplier: 0.4,
      ventFlowPerM2InM3PerS: 0.00015,
      heatSet: 20,
      coolSet: 26,
      deadbandK: 3,
      postHeatingTemp: 17,
    },
  },
  {
    operation: { wdays: [[6, 7]], hours: [[15, 23]] },
    properties: {
      occupantMultiplier: 0.02,
      activityMultiplier: 0.2,
      ventFlowPerM2InM3PerS: 0.0001,
      heatSet: 19,
      coolSet: 27,
      deadbandK: 3,
    },
  },
];
